import * as theme from "../theme";
import _ from "lodash";
import SimpleQuestion from "./SimpleQuestion";
import { NumericFormat } from "react-number-format";
import { OrangeButton } from "../general/OrangeButton";
import { isAnswerEmpty } from "../store/helperfuncs";
import { AiFillCalculator } from "react-icons/ai";
import { INSURER } from "../store/businesslogic/hardwiredlogic";
import Modal from "react-modal";
import CancelIcon from "@material-ui/icons/Cancel";
import Message from "./Message";
import Question from "../questions/Question";
import { CompareSharp } from "@material-ui/icons";
import { useEffect, useState, useRef, useMemo, createRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getQFuserMode } from "../store/components";
import { BROKER, CLIENT } from "../store/businesslogic/hardwiredlogic";
import { getBrokerInformation } from "../store/broker";

import {
  updateProspectForms,
  updateProspectFormsForClient,
  answerChanged,
  addMetaData,
  AddtoClientLog,
} from "../store/qf";
import translations from "../utils/translations";

const PercentageCalculator = ({
  text,
  parentNode,
  handleAnswerChange,
  isNodeOpen,
  fontSize,
  qfusermode,
}) => {
  var [showCalculateModal, setshowCalculateModal] = useState(false);
  var initialData = [
    {
      Title: {
        en: "Last 12 months",
        fr: "Derniers 12 mois",
      },
      Title_font: "Large",
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "aa",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: false,
    },
    {
      Title: {
        en: "Net profit (before taxes)",
        fr: "Bénéfice net (avant impôts)",
      },
      Title_font: "Large",
      id: "b",
      helpText: {
        en: "This should reflect the total net profit before taxes for the prior 12 months.",
        fr: "Cela devrait refléter le bénéfice net total avant impôts pour les 12 mois précédents.",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Standing Charges",
        fr: "Charges permanentes",
      },
      Title_font: "Large",
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "a",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: false,
    },
    {
      Title: {
        en: "Advertising",
        fr: "Publicité",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Agency contracts & expenses",
        fr: "Contrats et dépenses d'agence",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Delivery, telephone and other contracted services",
        fr: "Livraison, téléphone et autres services contractés",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Depreciation of buildings, fixtures, fittings & vehicles",
        fr: "Amortissement des bâtiments, installations, équipements et véhicules",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Charitable donations, trade subscriptions",
        fr: "Dons de bienfaisance, abonnements commerciaux",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Auditors and other fees",
        fr: "Frais d'auditeurs et autres frais",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Heat, light and power under contract",
        fr: "Chauffage, éclairage et énergie sous contrat",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Insurance premiums",
        fr: "Primes d'assurance",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Travelling expenses",
        fr: "Frais de déplacement",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Mortgage & loan payments",
        fr: "Paiements hypothécaires et de prêts",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Maintenance contracts",
        fr: "Contrats de maintenance",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Rents payable",
        fr: "Loyers à payer",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Salaries of executives and permanent staff",
        fr: "Salaires des cadres et du personnel permanent",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Technology and cloud fixed costs",
        fr: "Coûts fixes de technologie et de cloud",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Taxes (other than those chargeable on profits)",
        fr: "Taxes (autres que celles imposables sur les bénéfices)",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Other fixed standing charges",
        fr: "Autres charges permanentes fixes",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
    },
    {
      Title: {
        en: "Standing Charges Subtotal",
        fr: "Sous-total des charges permanentes",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "d",
      helpText: {
        en: "This should reflect the total ongoing costs of your business in the event that it was not able to operate for a year.",
        fr: "Cela devrait refléter le coût total continu de votre entreprise dans le cas où elle ne pourrait pas fonctionner pendant un an.",
      },
      InputBox: true,
      node: {
        logic: { sum: ["c"] },
      },
    },
    {
      Title: {
        en: "Gross Profits Subtotal",
        fr: "Sous-total des bénéfices bruts",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "e",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
      node: {
        logic: { sum: ["d", "b"] },
      },
    },
    {
      Title: {
        en: "Anticipated growth rate in next 12 months (%)",
        fr: "Taux de croissance anticipé au cours des 12 prochains mois (%)",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "f",
      helpText: {
        en: "Allows you to adjust for an overall growth in limits required.",
        fr: "Vous permet d'ajuster la croissance globale des limites requises.",
      },
      InputBox: true,
      TypeBox: "Percentage",
      node: {
        logic: { manual: true, inputVerify: true },
      },
    },
    {
      Title: {
        en: "Required period of indemnity (months)",
        fr: "Période d'indemnisation requise (mois)",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "fa",
      helpText: {
        en: "Actual loss duration can extend beyond 12 months and you can request coverage for this.",
        fr: "La durée réelle de la perte peut dépasser 12 mois et vous pouvez demander une couverture pour cela.",
      },
      InputBox: true,
      TypeBox: "Number",
      DefaultAnswer: "12",
      RootFormQuestionId: "47090",
      parentNode: {
        id: 47090,
        type: "number",
        formid: "e_91000",
      },
      answer: 12,
      node: {
        logic: { manual: true, inputVerify: true },
        answer: 12,
      },
    },
    {
      Title: {
        en: "Gross Profits Excluding Ordinary Payroll",
        fr: "Bénéfices bruts excluant la paie ordinaire",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "g",
      helpText: {
        en: "This is the total Profits amount that will be requested from insurers.",
        fr: "C'est le montant total des bénéfices qui sera demandé aux assureurs.",
      },
      InputBox: true,
      RootFormQuestionId: "47060",
      parentNode: {
        id: 47060,
        type: "currency",
        formid: "e_91000",
      },
      node: {
        logic: { manual: true },
      },
    },
    {
      Title: {
        en: "Include Ordinary Payroll?",
        fr: "Inclure la paie ordinaire ?",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "k",
      helpText: {
        en: "In order to include the ongoing costs of staff who are not Executives, Managers, or employees under contract, you would need to have ordinary payroll coverage.",
        fr: "Afin d'inclure les coûts continus du personnel qui ne sont pas des cadres, des gestionnaires ou des employés sous contrat, vous devrez avoir une couverture de la paie ordinaire.",
      },
      InputBox: false,
      node: {
        type: "yesno",
        answer: "Yes",
        logic: {
          Yes: {
            showQuestions: [25, 26, 27],
          },
          No: {
            hideQuestions: [25, 26, 27],
          },
        },
      },
    },
    {
      Title: {
        en: "Total ordinary payroll (annual)",
        fr: "Paie ordinaire totale (annuelle)",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c1",
      helpText: {
        en: "Add the annual value of contracted, temporary or seasonal staff.",
        fr: "Ajoutez la valeur annuelle du personnel contracté, temporaire ou saisonnier.",
      },
      InputBox: true,
      hide: false,
    },
    {
      Title: {
        en: "# Months of payroll coverage",
        fr: "# Mois de couverture de la paie",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c2",
      helpText: {
        en: "Insurers will often limit this coverage to 3-6 months, but you can request a longer duration if required.",
        fr: "Les assureurs limiteront souvent cette couverture à 3-6 mois, mais vous pouvez demander une durée plus longue si nécessaire.",
      },
      TypeBox: "Number",
      InputBox: true,
      hide: false,
      RootFormQuestionId: "47125",
      parentNode: {
        id: 47125,
        type: "number",
        formid: "e_91000",
      },
    },
    {
      Title: {
        en: "Ordinary payroll coverage",
        fr: "Couverture de la paie ordinaire",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c3",
      helpText: {
        en: "This reflects 80% of the costs of ordinary payroll for the duration requested.",
        fr: "Cela reflète 80% des coûts de la paie ordinaire pour la durée demandée.",
      },
      InputBox: true,
      hide: false,
      RootFormQuestionId: "47130",
      parentNode: {
        id: 47130,
        type: "currency",
        formid: "e_91000",
      },
      node: {
        logic: { manual: true },
      },
    },
    {
      Title: {
        en: "Total Gross Profits",
        fr: "Bénéfices bruts totaux",
      },
      subtitleText: {
        en: "Charges that would continue if the business is not operating in the event of a claim",
        fr: "Charges qui continueraient si l'entreprise ne fonctionne pas en cas de sinistre",
      },
      id: "c4",
      helpText: {
        en: "",
        fr: "",
      },
      InputBox: true,
      hide: false,
      node: {
        logic: { sum: ["g", "c3"] },
      },
    },
  ];

  console.log("big tuness", initialData);
  var test = parentNode?.metaData?.calculatorform
    ? JSON.parse(JSON.stringify(parentNode.metaData.calculatorform))
    : initialData;
  var intialForm = parentNode?.metaData?.calculatorform;
  var calculatorform = test;
  var [formLayoutData, setformLayoutData] = useState(calculatorform);
  const dispatch = useDispatch();
  const [windowsize, setwindowsize] = useState(0);
  const recalulate = (idx, ans) => {
    var tempFormLayoutData = JSON.parse(JSON.stringify(formLayoutData));
    if (!tempFormLayoutData[idx].node) tempFormLayoutData[idx].node = {};
    tempFormLayoutData[idx].node.answer = ans;

    if (tempFormLayoutData[idx].node.logic?.[ans]?.hideQuestions) {
      for (var id of tempFormLayoutData[idx].node.logic[ans].hideQuestions) {
        tempFormLayoutData[id].hide = true;
      }
    }
    if (tempFormLayoutData[idx].node.logic?.[ans]?.showQuestions) {
      for (var idx of tempFormLayoutData[idx].node.logic[ans].showQuestions) {
        tempFormLayoutData[idx].hide = false;
      }
    }
    for (var idx in tempFormLayoutData) {
      if (tempFormLayoutData[idx].node?.logic) {
        if (tempFormLayoutData[idx].node?.logic.sum) {
          var total = 0;
          tempFormLayoutData[idx].node?.logic.sum.map((tx) => {
            var filteredList = tempFormLayoutData.filter(
              (x) => x.id == tx && x.node?.answer
            );
            var v = tempFormLayoutData
              .filter((x) => x.id == tx && x.node?.answer && !x.hide)
              .reduce((acc, b) => {
                if (b.node?.answer) {
                  return acc + parseFloat(b.node?.answer);
                } else return acc;
              }, 0);

            total += v;
          });
          tempFormLayoutData[idx].node.answer = total;
          tempFormLayoutData[idx].answer = total;
        }
        if (tempFormLayoutData[idx].node?.logic.manual) {
          if (tempFormLayoutData[idx].id == "c3") {
            var c1 = tempFormLayoutData.find((x) => x.id == "c1")?.node?.answer;
            var c2 = tempFormLayoutData.find((x) => x.id == "c2")?.node?.answer;
            if (c1 && c2) {
              tempFormLayoutData[idx].node.answer = (
                c1 *
                (c2 / 12) *
                0.8
              ).toFixed(2);
            } else {
              tempFormLayoutData[idx].node.answer = 0;
            }
          }
          if (tempFormLayoutData[idx].id == "g") {
            var c1_ = tempFormLayoutData.find((x) => x.id == "f")?.node?.answer;
            var c2_ = tempFormLayoutData.find((x) => x.id == "e")?.node?.answer;
            var c1b = tempFormLayoutData.find((x) => x.id == "fa")?.node
              ?.answer;
            if (c2_) {
              tempFormLayoutData[idx].node.answer = (
                ((c1_ / 100) * c2_ + c2_) *
                (c1b / 12)
              ).toFixed(2); //(c2 + ((c1/100) * c2 )).toFixed(2)
            }
          }
          if (tempFormLayoutData[idx].id == "f") {
            var c2x = tempFormLayoutData.find((x) => x.id == "e")?.node?.answer;
            if (!tempFormLayoutData[idx].node.answer)
              tempFormLayoutData[idx].node.answer = 0;
            tempFormLayoutData[idx].helpText =
              "$" +
              ((tempFormLayoutData[idx].node.answer / 100) * c2x).toFixed(0);
          }
        }
      }
      if (
        tempFormLayoutData[idx].RootFormQuestionId &&
        tempFormLayoutData[idx].node?.answer
      ) {
        console.log(
          "Set Parent Answer ",
          tempFormLayoutData[idx].RootFormQuestionId,
          " with ",
          tempFormLayoutData[idx].node?.answer
        );
        console.log(tempFormLayoutData[idx].parentNode);
        dispatch(
          answerChanged({
            node: tempFormLayoutData[idx].parentNode,
            changedValue: tempFormLayoutData[idx].node?.answer,
          })
        );
      }
      // if(parentNode.id == tempFormLayoutData[id].parentNode?.id){
      //   dispatch(answerChanged( { node:tempFormLayoutData[id].parentNode, changedValue:{ 'mainanswer': tempFormLayoutData[id].node?.answer, 'calculateForm': [...tempFormLayoutData] } } ));
      // }
    }

    setformLayoutData([...tempFormLayoutData]);
    dispatch(
      addMetaData({
        node: parentNode,
        metaValue: { calculatorform: [...tempFormLayoutData] },
      })
    );
  };
  let brokerInfo = useSelector(getBrokerInformation);
  const languagepreference = brokerInfo.information.languagepreference;
  const itemsRef = useRef([]);
  const navArr = useMemo(() =>
    Array(20)
      .fill(0)
      .map((i) => createRef())
  );
  useEffect(() => {
    itemsRef.current = itemsRef.current.slice(0, formLayoutData.length);
  }, [formLayoutData]);
  const NumberInput = ({
    node,
    handleAnswerChange,
    error,
    label,
    qfusermode,
    typeBox,
    counterInput,
  }) => {
    // const currentnode = useSelector(getCurrentNode);
    // const isOnThisNode = node.id === currentnode.id;
    const [input, setInput] = useState(
      isAnswerEmpty(node.answer) ? null : node.answer
    );

    useEffect(() => {
      if (input != node.answer && node.answer) {
        setInput(node.answer);
      }
    }, [node.answer]);

    const handleAnswer = (input) => {
      if (input === "" || input === null) {
        handleAnswerChange(null);
      } else if (!isNaN(input)) {
        handleAnswerChange(Number(input));
      }
    };

    const handleTab = (e) => {
      if (e.key == "Tab") {
        e.preventDefault();

        var focusId = "numberInput" + (counterInput + 1);

        //setTimeout(() => {
        var nextIdtab = document.getElementById(focusId);
        var tabCounter = 1;
        while (
          !nextIdtab ||
          nextIdtab?.disabled ||
          nextIdtab?.getAttribute("disabled")
        ) {
          focusId = "numberInput" + (counterInput + tabCounter);
          nextIdtab = document.getElementById(focusId);
          if (nextIdtab?.disabled || nextIdtab?.getAttribute("disabled")) {
            nextIdtab = null;
          }
          tabCounter += 1;
        }
        nextIdtab.select();
        // navArr[counterInput+1].current.select();
        // itemsRef.current[(counterInput+1)].select();
        // itemsRef.current[(counterInput+1)].focus();
        //}, 10);
      }
    };

    const handleBlur = (event) => {
      if (node.answer != input) handleAnswer(input);
    };

    const handleChange = (event) => {
      let input = event.value;
      if (input === "" || input === null || input === undefined) {
        setInput(null);
      } else if (!isNaN(input)) setInput(input);
    };
    var disableInput = false;
    if (node.logic?.sum || (node.logic?.manual && !node.logic?.inputVerify)) {
      disableInput = true;
    }
    // const dispatch = useDispatch();
    var placeholder = "$";
    var suffix = "";
    if (typeBox == "Percentage") {
      placeholder = "";
      suffix = "%";
    } else if (typeBox == "Number") {
      placeholder = "";
      suffix = "";
    }
    return (
      <NumericFormat
        type="text"
        ref={(el) => (itemsRef.current[counterInput] = el)}
        onKeyDown={(e) => handleTab(e)}
        placeholder={placeholder}
        prefix={placeholder}
        suffix={suffix}
        disabled={disableInput}
        tabIndex="1"
        thousandSeparator={true}
        inputMode="numeric"
        id={"numberInput" + counterInput}
        style={{ ...theme.inputStyle, width: "9vw" }}
        value={input}
        onValueChange={handleChange}
        onBlur={handleBlur}
        readOnly={qfusermode === INSURER ? true : false}
      ></NumericFormat>
    );
  };
  const qfUserMode = useSelector(getQFuserMode);

  return (
    <>
      <AiFillCalculator
        onClick={(e) => {
          setshowCalculateModal(true);
        }}
        size={28}
        style={{ cursor: "pointer" }}
      ></AiFillCalculator>
      <Modal
        size="md"
        isOpen={showCalculateModal}
        ariaHideApp={false}
        shouldCloseOnEsc={true}
        centered
        style={{
          overlay: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme.COLORS.rgba_primary_navyblue,
          },
          content: {
            height: "95vh",
            width: "60vw",
            position: "absolute",
            top: "1vh",
            left: "24vw",
            background: "#eef3f6",
            WebkitOverflowScrolling: "touch",
            border: "8px solid " + theme.COLORS.white_Indo,
            borderRadius: "20px",
            padding: 0,
            overflowY: "auto",
            overflowX: "hidden",
          },
        }}
      >
        <div style={{ position: "absolute", top: 0, right: 0 }}>
          <CancelIcon
            fontSize="large"
            style={{ cursor: "pointer", color: "white" }}
            onClick={() => {
              dispatch(
                addMetaData({
                  node: parentNode,
                  metaValue: { calculatorform: formLayoutData },
                })
              );

              setshowCalculateModal(false);
            }}
          ></CancelIcon>
        </div>

        <div
          style={{
            width: "100%",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              backgroundColor: theme.COLORS.secondary_skyblue,
              fontSize: "1.9vmin",
              letterSpacing: 1,
              display: "block",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              fontFamily: "GibsonRegular",
              paddingTop: "1%",
              paddingBottom: "2%",
            }}
          >
            <h2 style={{ textAlign: "center" }}>
              {
                translations[languagepreference]
                  .businessInterruptionCalculatorTitle
              }
            </h2>
            <p style={{ textAlign: "center", fontSize: "20px" }}>
              {
                translations[languagepreference]
                  .businessInterruptionCalculatorDescription
              }
            </p>
          </div>
        </div>

        <div
          style={{
            backgroundColor: "rgb(63, 68, 90)",
            display: "flow-root",
            color: "white",
            fontFamily: "GibsonRegular",
          }}
        >
          <div>
            {formLayoutData.map((simpleQuestion, idx) => {
              if (simpleQuestion.hide) {
                return <></>;
              }

              if (simpleQuestion.InputBox) {
                return (
                  <div
                    class="row"
                    style={{
                      borderBottom: "dotted rgb(80 76 83) 0.1px",
                      marginLeft: "20px",
                    }}
                  >
                    <div style={{ width: "65%" }}>
                      <SimpleQuestion
                        leftString={simpleQuestion.Title[languagepreference]}
                        node={
                          formLayoutData[idx].node
                            ? formLayoutData[idx].node
                            : {}
                        }
                        textColor="white"
                        minHeight="6vh"
                        qTextWidthExlpicit="65%"
                        width="auto"
                        rightComponent={
                          <>
                            {simpleQuestion.InputBox ? (
                              <NumberInput
                                node={
                                  formLayoutData[idx].node
                                    ? formLayoutData[idx].node
                                    : {}
                                }
                                handleAnswerChange={(e) => {
                                  recalulate(idx, e);
                                }}
                                // ref={el => itemsRef.current[idx] = el}
                                qfusermode={qfusermode}
                                typeBox={simpleQuestion.TypeBox}
                                counterInput={idx}
                              ></NumberInput>
                            ) : null}
                          </>
                        }
                      ></SimpleQuestion>
                    </div>

                    <div
                      style={{
                        width: "30%",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      {simpleQuestion.helpText[languagepreference]}
                    </div>
                  </div>
                );
              } else if (simpleQuestion.node?.type) {
                const QuestionComponent = Question({
                  type: simpleQuestion.node?.type,
                });
                return (
                  <div
                    class="row"
                    style={{
                      borderBottom: "dotted rgb(80 76 83) 0.1px",
                      marginLeft: "20px",
                    }}
                  >
                    <div style={{ width: "65%" }}>
                      <QuestionComponent
                        text={simpleQuestion.Title[languagepreference]}
                        textColor="white"
                        node={formLayoutData[idx].node}
                        qTextWidthExlpicit="inherit"
                        handleAnswerChange={(e) => {
                          recalulate(idx, e);
                        }}
                        stylecss={{
                          textColor: "white",
                          qTextWidthExlpicit: "65%",
                        }}
                        isNodeOpen={isNodeOpen}
                        qfusermode={qfusermode}
                        // hint={simpleQuestion.helpText}
                      ></QuestionComponent>
                    </div>
                    <div
                      style={{
                        width: "30%",
                        alignItems: "center",
                        display: "flex",
                      }}
                    >
                      {simpleQuestion.helpText[languagepreference]}
                    </div>
                  </div>
                );
              } else {
                return (
                  <div class="row" style={{ marginLeft: "5px" }}>
                    <Message
                      text={simpleQuestion.Title[languagepreference]}
                      node={{ importance: 1 }}
                      textColor="white"
                    ></Message>
                  </div>
                );
              }
            })}
          </div>
          <div
            style={{
              margin: "3% 50%",
            }}
          >
            <OrangeButton
              bgColor={theme.COLORS.secondary_orange}
              text={translations[languagepreference].saveAndComplete}
              height="5.6vmin"
              minwidth="17vmin"
              width="17vmin"
              onClick={() => {
                //parentNode.detailCalculator = formLayoutData;
                var newParentNode = {
                  ...parentNode,
                  detailCalculator: formLayoutData,
                };
                dispatch(
                  addMetaData({
                    node: parentNode,
                    metaValue: { calculatorform: formLayoutData },
                  })
                );
                if (qfUserMode == CLIENT) {
                  var newentry = {
                    question: "Profit Calculator",
                    old_answer: "",
                    new_answer: "Has been changed",
                  };
                  dispatch(AddtoClientLog({ newentry }));
                }
                setshowCalculateModal(false);
              }}
            ></OrangeButton>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default PercentageCalculator;
